import GlobalTagItemType from "@/enum/elements";
const moment = require("moment");
import {VUE_APP_HOST} from './globals';

let randomString = (length) => {
  let result = '';
  let characters = 'ABCDEFGHIJKLMNPQRSTUVWXYZ0123456789';
  let charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

export function generateUuidNo(length = 30)  {
  // 4 + 6 + 10
  let s =  moment().utcOffset(480).format('YYYYMMDD') + randomString(length - 8);
  return s;
}


export function leadingSlash(str) {
  return str.startsWith('/') ? str : '/' + str
}

export function trailingSlash(str) {
  return str.endsWith('/') ? str : str + '/'
}

export const wait = timeout => {
  return new Promise(resolve => setTimeout(resolve, timeout))
}

export function formatModel(model, ignore = []) {
  const keys = Object.keys(model)
  const data = {}
  // ignore.push('created_at');
  // ignore.push('updated_at');
  for (let i = 0; i < keys.length; i++) {
    const key = keys[i]
    if (ignore.indexOf(key) >= 0) continue
    data[key] = model[key]
  }
  // console.log("formatModel", data);
  return data
}

export function getColor(value, header) {
  if (header.color !== undefined) return header.color;
  if (header.color_map !== undefined) return header.color_map[value];
  switch (value) {
    case true:
    case 'success':
      return 'success'
    case false:
    case 'primary':
      return 'primary'
    case 'secondary':
      return 'secondary';
    case 'accent':
      return 'accent';
    case 'info':
      return 'info';
    case 'warning':
      return 'warning';
    case 'error':
      return 'error';
    default:
      return '';
  }
}

export function getMediaUrl(item, type = 'thumb') {
  if (item === undefined || item === null) return undefined;
  let host = item['url'] !== null ? item['url'] : VUE_APP_HOST;
  if (type === 'original') return host + (item['destination'] + '/' + item['file_name']);
  let url = host + (item['destination'] + '/' + type + '/' + item['file_name']);
  if (item['custom_properties'] === undefined ||
    item['custom_properties']['conversions'] === undefined ||
    item['custom_properties']['conversions']['thumb'] !== true) {
    url = host + (item['destination'] + '/' + item['file_name']);
  }
  return url;
}


export function getThumbUrl(host, item) {
  if (item === undefined) return undefined;
  let media;
  if (item.Media !== undefined) {
    media = item.Media;
  } else if (item.Medias !== undefined && item.Medias.length > 0) {
    media = item.Medias[0];
  }
  if (media === undefined) return undefined;
  if (media.url !== undefined && media.url !== null) host = media.url;
  if (media.custom_properties.conversions === undefined || media.custom_properties.conversions.thumb !== true) {
    return host + (media.destination + '/' + media.file_name);
  }

  return host + (media.destination + '/thumb/' + media.file_name);
}

export function clickAction(self, item, data) {
  console.log('click ' + data.action)
  switch (data.action) {
    case 'updateItem':
      updateItem(self, item, data);
      break;
    case 'goto':
      gotoItem(self, item, data);
      break;
  }
}

export async function updateItem(self, item, data) {
  try {
    const result = await self.$dialog.confirm({
      width: '300px',
      title: '資訊',
      text: '請問是否' + data.text + '?',
    });
    console.log(result);
    if (result !== true) return;

    const response = await self.$http.put(self.url + self.data_name + '/' + item.id, data.data, {
      headers: await self.$store.dispatch('getAuthHeader'),
    })
    const keys = Object.keys(data.data);
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];
      item[key] = data.data[key];
    }
    // Object.assign(self, item, data.data);
    if (checkError(self.$dialog, response)) {
      self.$dialog.info({
        width: '300px',
        title: '資訊',
        text: data.text + '成功',
      });
    }
  } catch (e) {
    console.error(e);
  }
}

export async function gotoItem(self, item, data) {
  self.$router.push(`/${data.element}/${item[self.id_name]}`);
}

export function isEmpty(value) {
  if (value === null || value === undefined) return true;
  if (Array.isArray(value) && value.length === 0) return true;
  if (typeof value === 'object' && Object.keys(value).length === 0) return true;
  return value.toString().length === 0;
}

export function getItemWithValue(itemField, value) {
  console.log('getItemWithValue itemField :', itemField);
  console.log('getItemWithValue value :', value);
  if (itemField === undefined || itemField === null) return null;
  if (itemField.items === undefined ||
    !Array.isArray(itemField.items)) {
    return null;
  }
  for (let i = 0; i < itemField.items.length; i++) {
    const item = itemField.items[i];
    if (item.text === value) return item;
  }
  console.log('all not match');
  return null;
}



export function clickCopy(str) {
  const textarea = document.createElement('textarea');
  textarea.value = str;
  document.body.appendChild(textarea);
  textarea.select();
  document.execCommand('copy');
  document.body.removeChild(textarea);
}

export function formPrice(priceData) {
  const { unit, price } = priceData;
  const formattedPrice = Number(price).toLocaleString('en-US');
  let symbol =  unit === "JPY" ?"¥" :"$";
  return `${unit} ${symbol} ${formattedPrice}`;
}

export function imgIsEmpty(img){
  if (isEmpty(img)) {
    return process.env.BASE_URL + "img/anya/anya01.png"
  } else {
    return getMediaUrl(img);
  }
}
